import styled, { css } from 'styled-components';
import { Checkbox } from 'antd';
import { colors, fontSize, fontWeight, radius, spacer } from 'settings/style';

export const CategoryOption = styled.div<{ $checked?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: ${spacer.md};
  padding: 14px 16px;
  border: 2px solid ${({ $checked }) => ($checked ? colors.primary : colors.cardBorder)};
  border-radius: ${radius.md};
  background: ${({ $checked }) => ($checked ? colors.primary100 : colors.white)};
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    border-color: ${colors.primary};
    box-shadow: 0 0 0 1px ${colors.primary100};
  }

  ${({ $checked }) =>
    $checked &&
    css`
      box-shadow: 0 0 0 3px ${colors.primary100};
    `}
`;

export const CategoryOptionLabel = styled.div`
  flex: 1;
  min-width: 0;
  font-weight: ${fontWeight.bold};
  font-size: ${fontSize.base};
  line-height: 1.4;
  color: ${colors.grey900};
  padding-top: 1px;
`;

export const CategoryCheckbox = styled(Checkbox)`
  flex-shrink: 0;
  align-items: flex-start;

  .ant-checkbox {
    align-self: flex-start;
    margin-top: 2px;
  }

  /* Visible ring outside the checkbox square */
  .ant-checkbox .ant-checkbox-inner {
    width: 20px;
    height: 20px;
    border-width: 2px;
    border-color: ${colors.grey700};
    box-shadow: 0 0 0 2px ${colors.white}, 0 0 0 4px ${colors.grey300};
  }

  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    border-color: ${colors.primary400};
    background-color: ${colors.primary400};
    box-shadow: 0 0 0 2px ${colors.white}, 0 0 0 4px ${colors.primary};
  }
`;

export const CategoryDescription = styled.p`
  margin: 8px 0 0 32px;
  font-weight: ${fontWeight.light};
  font-size: ${fontSize.sm};
  line-height: 1.45;
  color: ${colors.gray600};
`;
